class UseraddressDataStorage {
    avalanche = process.env.PROFILE_DATA_TARGET === "avalanche";
    avalancheProvider;
    constructor(avalancheProvider) {
        this.avalancheProvider = avalancheProvider;
    }
    async set(key, toStore) {
        if (this.avalanche) {
            this.avalancheProvider.setUserAddress(key, toStore);
        }
    }
    async get() {
        if (this.avalanche) {
            return this.avalancheProvider.getAllUserAddress();
        }
        return undefined;
    }
}
export default UseraddressDataStorage;
